import { useDisclosure } from "@chakra-ui/react";
import { useState } from "react";
import { BiPlus } from "react-icons/bi";
import { Button } from "../../../components/ui/button";
import Workspace from "../../../components/workspace";
import GroupForm from "./group-form";
import GroupListContainer from "./group-list-container";

const GroupManagement = () => {
   const [searchQuery, setSearchQuery] = useState("");
   const formModal = useDisclosure();

   return (
      <>
         <GroupForm modal={formModal} />
         <Workspace.TopBar heading="Group Management" />
         <Workspace.WorkspaceActions>
            <Button variant="primary" onClick={formModal.onOpen}>
               <span className="inline-flex items-center gap-2">
                  <BiPlus />
                  Create new group
               </span>
            </Button>
         </Workspace.WorkspaceActions>
         <Workspace.ComponentWrapper>
            <Workspace.ListContainerHeader>
               <Workspace.HeaderPadding>
                  <Workspace.ListTitleWrapper>
                     <Workspace.ListTitle>Groups</Workspace.ListTitle>
                     <Workspace.HeaderSearchWrapper>
                        <Workspace.HeaderSearchForm onSubmit={setSearchQuery} />
                     </Workspace.HeaderSearchWrapper>
                  </Workspace.ListTitleWrapper>
               </Workspace.HeaderPadding>
            </Workspace.ListContainerHeader>
            <GroupListContainer searchQuery={searchQuery} />
         </Workspace.ComponentWrapper>
      </>
   );
};

export default GroupManagement;
